export const voices = [
  {
    quote:
      "以前刷到热搜一头雾水，现在习惯先来这儿看一篇梳理，几分钟就搞懂前因后果，吃瓜终于不再是只看情绪。",
    name: "前排小板凳",
    role: "老读者 · 关注网络热议",
  },
  {
    quote:
      "难得的是态度克制。同类站点喜欢把话说得很满，这里会明确告诉你哪些还没证实，读起来踏实。",
    name: "夜猫子阿瓜",
    role: "订阅用户 · 关注社会百态",
  },
  {
    quote:
      "分类做得清楚，想放松就看生活趣闻，想认真点就翻网络热议。工作日下午的摸鱼时间基本都交代在这儿了。",
    name: "办公室吃瓜员",
    role: "常驻读者 · 关注娱乐风向",
  },
  {
    quote:
      "期待已久的话题复盘很到位。很多热点凉了之后没人再讲，这里会补一篇总结，这点特别加分。",
    name: "只蹲前排",
    role: "订阅用户 · 关注科技新鲜事",
  },
];

export const principles = [
  {
    icon: "ri-shield-check-line",
    title: "只讲可查证的部分",
    desc: "我们梳理公开可查的信息，对尚未证实的内容会明确标注，不把猜测写成结论。",
  },
  {
    icon: "ri-user-heart-line",
    title: "不针对个人定性",
    desc: "讨论聚焦事件与现象本身，避免对任何个人作出带有攻击性的评判。",
  },
  {
    icon: "ri-book-open-line",
    title: "给你完整的脉络",
    desc: "不满足于一句爆料，我们尽量还原事情的来龙去脉，让你自己作判断。",
  },
  {
    icon: "ri-refresh-line",
    title: "热度过后的复盘",
    desc: "话题降温不等于结束，我们会补上复盘，帮你看清它为什么热、又为什么凉。",
  },
];